/**
 * Placeholder component for starter template.
 * Replace this with your shared web components.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
let RemoveReplaceMe = class RemoveReplaceMe extends LitElement {
    static { this.styles = css `
    :host {
      display: block;
      padding: 2rem;
      background: var(--md-sys-color-surface-variant, #f5f5f5);
      border-radius: 0.5rem;
      border: 1px solid var(--md-sys-color-outline, #ccc);
      font-family: var(--md-sys-typescale-body-large-font, system-ui, sans-serif);
      color: var(--md-sys-color-on-surface, #1f1f1f);
    }
  `; }
    render() {
        return html `
      <p>placeholder - your shared web components go here</p>
    `;
    }
};
RemoveReplaceMe = __decorate([
    customElement('remove-replace-me')
], RemoveReplaceMe);
export { RemoveReplaceMe };
//# sourceMappingURL=remove-replace-me.js.map